import { createSlice } from "@reduxjs/toolkit";
import { api } from "./api";

const userToken = localStorage.getItem("userToken")
  ? localStorage.getItem("userToken")
  : null;

const slice = createSlice({
  name: "auth",
  initialState: {
    userInfo: {
      role: null,
      name: null,
      email: null,
      contact: null,
      _id: null,
    },
    userToken,
    error: null,
    loading: false,
    success: false,
  },
  reducers: {
    setCredentials: (state, { payload }) => {
      state.userInfo = payload;

      localStorage.setItem("userInfo", JSON.stringify(payload));
    },
    logout: (state) => {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("userToken");

      state.userInfo = null;
      state.userToken = null;
      state.error = null;
      state.loading = false;

      // clear the state and history
      // window.location.href = "/login";
    },
  },

  extraReducers: (builder) => {
    // register user
    builder.addMatcher(
      api.endpoints.registerUser.matchFulfilled,
      (state, action) => {
        state.success = true;
        state.loading = false;
        state.error = null;
      }
    );
    builder.addMatcher(
      api.endpoints.registerUser.matchPending,
      (state, action) => {
        state.success = false;
        state.loading = true;
        state.error = null;
      }
    );
    builder.addMatcher(
      api.endpoints.registerUser.matchRejected,
      (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.error.message;
      }
    );
    // login user
    builder.addMatcher(api.endpoints.login.matchFulfilled, (state, action) => {
      state.userToken = action.payload.token;
      state.userInfo = action.payload.user;
      state.loading = false;
      state.error = null;
    });
    builder.addMatcher(api.endpoints.login.matchPending, (state, action) => {
      state.loading = true;
      state.error = null;
    });
    builder.addMatcher(api.endpoints.login.matchRejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export const { setCredentials, logout } = slice.actions;

export default slice.reducer;
